/* App bar — ported from the prototype's appbar(). Primary nav, fund name + avatar.
   `embedded` renders a slim nav-only row for the in-dashboard tab (no brand bar,
   avatar or theme toggle — dark mode was removed). Nav uses react-router Links;
   the active item is derived from the current path. */
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { BASE } from '../helpers';
import { useProfile } from '../state';

const NAV = [
	['pipeline', 'Pipeline'],
	['dashboard', 'Dashboard'],
	['profile', 'Investor profile'],
	['sandbox', 'Idea sandbox'],
];

function activeKey(pathname) {
	const rest = pathname.replace(BASE, '');
	const seg = rest.split('/').filter(Boolean)[0] || 'pipeline';
	return NAV.some(([k]) => k === seg) ? seg : '';
}

export default function AppBar({ embedded = false }) {
	const { pathname } = useLocation();
	const active = activeKey(pathname);
	const [mobileOpen, setMobileOpen] = useState(false);
	const { profile } = useProfile();
	const fundShort = (profile && profile.short) || 'Deal flow';
	const fundInitials = (profile && profile.initials) || '·';

	const navLinks = NAV.map(([key, label]) => (
		<Link key={key} to={`${BASE}/${key}`} className={key === active ? 'is-active' : ''}
			onClick={() => setMobileOpen(false)}>{label}</Link>
	));

	// Inline dashboard tab: a single slim nav row, matching the other tabs' look.
	if (embedded) return <nav className="embednav" aria-label="Deal management menu">{navLinks}</nav>;

	return (
		<>
			<header className="appbar">
				<button className="hamburger" onClick={() => setMobileOpen(o => !o)} aria-label="Menu" aria-expanded={mobileOpen}>
					<svg width="18" height="14" viewBox="0 0 18 14"><rect y="0" width="18" height="2" rx="1" /><rect y="6" width="18" height="2" rx="1" /><rect y="12" width="18" height="2" rx="1" /></svg>
				</button>
				<nav className="appbar__nav">{navLinks}</nav>
				<span className="appbar__fund">{fundShort}</span>
				<span className="appbar__avatar">{fundInitials}</span>
			</header>
			{mobileOpen && <div className="mobilenav__scrim" onClick={() => setMobileOpen(false)} />}
			<nav className={`mobilenav${mobileOpen ? ' is-open' : ''}`} aria-label="Main menu">{navLinks}</nav>
		</>
	);
}
